// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"b7-z"};